const imgurClientId = 'cb9f6e95e757629';

function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type:mimeString});
}

function upload(dataUrl, callback) {
  var blob = dataURItoBlob(dataUrl);
  var fd = new FormData();
  fd.append("upload", blob);

  return fetch('http://uploads.im/api', {
    method: 'POST',
    body: fd
  })
  .then(checkStatus)
  .then(parseJSON)
  .then(callback);
}

function saveToDb(imageUrl) {
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };

  const body = {
    imageUrl: imageUrl
  };

  return fetch('/api/v1/chromatic/save', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  })
  .then(checkStatus)
  .then(parseJSON)
}

function uploadToImgur(file, callback) {
  var formData = new FormData();
  formData.append('image', file);
  return fetch('https://api.imgur.com/3/image', {
    method: 'POST',
    headers: {
      Authorization: 'Client-ID ' + imgurClientId,
    },
    body: formData
  })
  .then(checkStatus)
  .then(parseJSON)
  .then(callback);
}

function saveFont(letterImages, previewUrl, callback) {
  const body = {
    font: letterImages,
    originalImage: previewUrl
  };

  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };

  return fetch('/api/v1/chromatic/saveFont', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  })
  .then(checkStatus)
  .then(parseJSON)
  .then(callback);
}

function getChromaticFont(callback) {
  return fetch(`/api/v1/chromatic/getFont`, {
    accept: 'application/json',
  }).then(checkStatus)
    .then(parseJSON)
    .then(callback);
}


function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    const error = new Error(`HTTP Error ${response.statusText}`);
    error.status = response.statusText;
    error.response = response;
    console.log(error); // eslint-disable-line no-console
    throw error;
  }
}

function parseJSON(response) {
  return response.json();
}

const ImageAPI = {
  upload,
  saveToDb,
  saveFont,
  uploadToImgur,
  getChromaticFont,
};
export default ImageAPI;



// WEBPACK FOOTER //
// ./src/api/ImageAPI.js